import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=58421e6b&scoped=true&lang=pug"
import script from "./Parceiros.vue?vue&type=script&lang=js"
export * from "./Parceiros.vue?vue&type=script&lang=js"
import style0 from "./Parceiros.styl?vue&type=style&index=0&id=58421e6b&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58421e6b",
  null
  
)

export default component.exports